import type en from "../en/call";
import type { Messages } from "../../types";

const fr: Messages<typeof en> = {
  callUs: "Appelez-nous",
  callAi: "Appeler l'IA",
  heroPrompt: "Vous ne savez pas par où commencer ? Parlez à une IA Storelancer",
  openCall: "Appeler un assistant IA Storelancer",
  modalTitle: "Expert IA Storelancer",
  chooseLanguage: "Choisissez la langue de l'appel",
  more: "Plus",
  moreLanguages: "Autres langues",
  selectLanguage: "Sélectionnez une langue",
  whoToTalk: "À qui souhaitez-vous parler ?",
  style_kind: "Bienveillant & patient",
  style_fast: "Rapide & pratique",
  style_store: "Boutique & business",
  style_apps: "Apps & produits",
  online: "En ligne",
  talkTo: "Appeler {name} ({style})",
  honestNote: "Assistants vocaux IA — pas de vraies personnes.",
  costNote: "Les appels peuvent consommer des crédits par minute : {n} ⚡/min",
  freeNote: "Les appels sont gratuits",
  balance: "Votre solde : {n} ⚡",
  close: "Fermer",
  aiAssistant: "Assistant IA",
  callDuration: "Durée de l'appel",
  connecting: "Connexion…",
  listening: "À l'écoute…",
  thinking: "Réflexion…",
  speaking: "Parle…",
  ready: "Prêt — écrivez un message",
  micMuted: "Micro coupé",
  waitingConfirm: "En attente de votre confirmation",
  ended: "Appel terminé",
  endedSummary: "Appel terminé · {minutes} min · {credits} ⚡",
  mute: "Couper le micro",
  unmute: "Réactiver le micro",
  hangUp: "Raccrocher",
  typeInstead: "Écrire plutôt",
  typePlaceholder: "Écrivez votre message…",
  send: "Envoyer",
  captions: "Sous-titres en direct",
  you: "Vous",
  steps: "Actions de l'assistant",
  confirmTitle: "Confirmer cette action",
  confirm: "Confirmer",
  cancel: "Annuler",
  greeting: "Bonjour, je suis {name}, votre assistant IA Storelancer. Comment puis-je vous aider aujourd'hui ?",
  sayConfirm: "Merci de confirmer à l'écran.",
  sayNoCredits: "Vous n'avez plus de crédits, l'appel est donc terminé. Vous pouvez en ajouter et rappeler.",
  sayMaxDuration: "Nous avons atteint la durée maximale de l'appel, il est donc terminé.",
  reasonNoCredits: "L'appel s'est terminé car vous n'avez plus de crédits.",
  reasonMaxDuration: "L'appel a atteint sa durée maximale.",
  reasonOther: "L'appel a été terminé par le serveur.",
  addCredits: "Ajouter des crédits",
  openStore: "Ouvrir votre boutique",
  callAgain: "Rappeler",
  errUnsupported: "Votre navigateur ne reconnaît pas la parole. Vous pouvez toujours écrire vos messages.",
  errPermission: "L'accès au micro a été refusé. Autorisez-le dans les réglages du navigateur, ou écrivez plutôt.",
  errNoMic: "Aucun micro détecté. Vous pouvez écrire plutôt.",
  errNetwork: "Le service vocal est injoignable. Vous pouvez écrire plutôt.",
  errFailed: "La reconnaissance vocale ne fonctionne plus. Vous pouvez écrire plutôt.",
  errNoSpeechOut: "Votre navigateur ne peut pas lire les réponses à voix haute — lisez-les dans les sous-titres.",
  errStart: "L'appel n'a pas pu démarrer.",
  errAiUnavailable: "L'assistant IA n'est pas configuré sur ce serveur.",
  errNoCreditsStart: "Vous n'avez pas assez de crédits pour démarrer un appel.",
  errTurn: "Une erreur est survenue. Veuillez réessayer.",
  avatarsTitle: "Portraits des personas d'appel",
  avatarsHelp: "Génère un portrait IA photoréaliste pour chaque persona d'appel avec le modèle d'images et l'enregistre. Les personas sont fictifs, pas de vraies personnes.",
  generateMissing: "Générer les portraits manquants",
  regenerateAll: "Tout régénérer",
  generating: "Génération des portraits… cela peut prendre quelques minutes.",
  generatedResult: "{created} créés, {skipped} déjà présents, {failed} en échec.",
  imagesNotConfigured: "La génération d'images n'est pas configurée sur ce serveur (REPLICATE_API_TOKEN absent).",
  noFemaleVoice: "Aucune voix féminine n’est encore définie pour cette langue : les réponses de {name} s’affichent en sous-titres. Un administrateur peut en choisir une dans Admin → IA et crédits → Labo des voix.",
  voiceProviderError: "Le service de voix a échoué ({error}) : les réponses s’affichent en sous-titres.",
  noMaleVoice: "Aucune voix masculine n’est encore définie pour cette langue : les réponses de {name} s’affichent en sous-titres. Un administrateur peut en choisir une dans Admin → IA et crédits → Labo des voix.",
  chooseDialect: "Quel arabe ?",
  dialectHint: "{name} écoutera et répondra dans ce dialecte.",
};

export default fr;
